import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { MessageService } from '../local/message.service';
import { AccountService } from './account.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService, private router: Router, private accountService: AccountService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((response: HttpErrorResponse) => {
        if (response.status >= 500) {
          this.messageService.error(response.statusText);
        } else {
          switch (response.status) {
            case 401:
              this.accountService.login().subscribe((response) => {
                if (response) {
                  if (response.hasOwnProperty('redirectUrl')) {
                    window.location.href = (response as any).redirectUrl;
                  }
                }
              });
              break;
            case 404:
              this.messageService.info(`Donnée introuvable`);
              break;
            case 409:
              return throwError({
                status: 409,
              });
            default:
              console.debug('error inter', response);
              if (response.error) {
                if (typeof response.error === 'string') {
                  this.messageService.error(response.error);
                } else if ('title' in response.error) {
                  this.messageService.error(response.error.title);
                }
              } else {
                this.messageService.error(response.message);
              }
              break;
          }
        }

        return throwError(undefined);
      })
    );
  }
}
